import { render, staticRenderFns } from "./XInputMetricCategory.vue?vue&type=template&id=7600a04e"
import script from "./XInputMetricCategory.vue?vue&type=script&lang=js"
export * from "./XInputMetricCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports